// components/connector/connector-selection.tsx
import React from "react";
import { Search } from "lucide-react";
import { ConnectorCard } from "./card";
import { Connector } from "../../types";

interface ConnectorSelectionProps {
  title: string;
  description: string;
  connectors: Connector[];
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedConnector: Connector | null;
  onSelectConnector: (connector: Connector) => void;
  onShowGuide: (connector: Connector) => void;
  onConfigure: (id: string) => void;
  placeholder: string;
}

export const ConnectorSelection: React.FC<ConnectorSelectionProps> = ({
  title,
  description,
  connectors,
  searchTerm,
  onSearchChange,
  selectedConnector,
  onSelectConnector,
  onShowGuide,
  onConfigure,
  placeholder,
}) => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          {title}
        </h1>
        <p className="text-gray-600">{description}</p>
      </div>

      {/* Search */}
      <div className="relative w-1/4 mb-6">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={onSearchChange}
          className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      {/* Categories - You can make this dynamic if needed */}
      <div className="flex space-x-4 mb-6">
        <button className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium">
          All
        </button>
        <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200">
          Database
        </button>
        <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200">
          Marketing
        </button>
        <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200">
          Analytics
        </button>
      </div>

      {/* Connectors Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {connectors.map((connector) => (
          <ConnectorCard
            key={connector.id}
            connector={connector}
            onConfigure={onConfigure}
            isSelected={selectedConnector?.id === connector.id}
            onSelect={onSelectConnector}
            onShowGuide={onShowGuide}
          />
        ))}
      </div>
    </div>
  );
};